var map = {
	"./bg-BG.json": 3047,
	"./ca-ES.json": 3048,
	"./cs-CZ.json": 3049,
	"./de-DE.json": 3050,
	"./el-GR.json": 3051,
	"./en-US.json": 1654,
	"./es-ES.json": 3052,
	"./et-EE.json": 3053,
	"./fi-FI.json": 3054,
	"./fr-FR.json": 3055,
	"./he-IL.json": 3056,
	"./it-IT.json": 3057,
	"./ja-JP.json": 3058,
	"./ko-KR.json": 3059,
	"./nb-NO.json": 3060,
	"./nl-NL.json": 3061,
	"./nn-NO.json": 3062,
	"./pl-PL.json": 3063,
	"./pt-BR.json": 3064,
	"./ro-RO.json": 3065,
	"./ru-RU.json": 3066,
	"./sk-SK.json": 3067,
	"./sv-SE.json": 3068,
	"./tr-TR.json": 3069,
	"./zh-CN.json": 3070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3046;